import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsNI: CultureInfo = {
  name: 'es-NI',
  displayName: 'Spanish (Nicaragua)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-NI',
  parent: CultureInfoEs
};
